import BaseInput, { SeturInputProps } from '@components/Input';
import { useHeight, useLabelTop } from '@components/utils/hooks/useSize';

const Input = (props: SeturInputProps) => {
  const height = useHeight();
  const labelTop = useLabelTop();
  return <BaseInput {...props} height={height} labelTop={labelTop} />;
};

export default Input;
